import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboard, Users, BarChart2, Link, BarChart, CreditCard, MessageSquare, ShieldAlert, TrendingUp, ChevronLeft, ChevronRight } from 'lucide-react';
interface SidebarProps {
  isOpen: boolean;
  toggleSidebar: () => void;
}
const Sidebar: React.FC<SidebarProps> = ({
  isOpen,
  toggleSidebar
}) => {
  const navItems = [{
    name: 'Dashboard',
    path: '/',
    icon: <LayoutDashboard size={20} data-id="element-87" />
  }, {
    name: 'Users',
    path: '/users',
    icon: <Users size={20} data-id="element-88" />
  }, {
    name: 'Analytics',
    path: '/analytics',
    icon: <BarChart2 size={20} data-id="element-89" />
  }, {
    name: 'Integrations',
    path: '/integrations',
    icon: <Link size={20} data-id="element-90" />
  }, {
    name: 'Investments',
    path: '/investments',
    icon: <BarChart size={20} data-id="element-91" />
  }, {
    name: 'Loans',
    path: '/loans',
    icon: <CreditCard size={20} data-id="element-92" />
  }, {
    name: 'Content & AI',
    path: '/content',
    icon: <MessageSquare size={20} data-id="element-93" />
  }, {
    name: 'System',
    path: '/system',
    icon: <ShieldAlert size={20} data-id="element-94" />
  }, {
    name: 'Business',
    path: '/business',
    icon: <TrendingUp size={20} data-id="element-95" />
  }];
  return <div className={`${isOpen ? 'w-64' : 'w-20'} transition-width duration-300 ease-in-out bg-white dark:bg-gray-800 border-r border-gray-200 dark:border-gray-700 relative h-full`} data-id="element-96">
      <div className="flex items-center justify-between h-16 px-4 border-b border-gray-200 dark:border-gray-700" data-id="element-97">
        <div className={`flex items-center ${isOpen ? 'justify-start' : 'justify-center'} w-full`} data-id="element-98">
          {isOpen ? <div className="flex items-center" data-id="element-99">
              <div className="h-8 w-8 rounded-md bg-blue-600 flex items-center justify-center" data-id="element-100">
                <span className="text-white font-bold" data-id="element-101">F</span>
              </div>
              <span className="ml-2 font-semibold text-xl dark:text-white" data-id="element-102">
                Fintrove
              </span>
            </div> : <div className="h-8 w-8 rounded-md bg-blue-600 flex items-center justify-center" data-id="element-103">
              <span className="text-white font-bold" data-id="element-104">F</span>
            </div>}
        </div>
        <button onClick={toggleSidebar} className="absolute -right-3 top-7 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-full p-1 shadow-md" data-id="element-105">
          {isOpen ? <ChevronLeft size={16} data-id="element-106" /> : <ChevronRight size={16} data-id="element-107" />}
        </button>
      </div>
      <nav className="mt-5 px-2" data-id="element-108">
        <div className="space-y-1" data-id="element-109">
          {navItems.map(item => <NavLink key={item.name} to={item.path} className={({
          isActive
        }) => `flex items-center px-2 py-2 text-sm font-medium rounded-md transition-colors ${isActive ? 'bg-blue-100 dark:bg-blue-900/50 text-blue-700 dark:text-blue-200' : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700'} ${!isOpen && 'justify-center'}`} data-id="element-110">
              <div className="flex items-center" data-id="element-111">
                {item.icon}
                {isOpen && <span className="ml-3" data-id="element-112">{item.name}</span>}
              </div>
            </NavLink>)}
        </div>
      </nav>
    </div>;
};
export default Sidebar;